import { env } from "./env";

export const CONTACT_EMAIL = "hello@kranbos.com";

/** Free consultation Calendly link tagged with `utm_content` so bookings show which CTA was clicked. */
export const calendlyHref = (ctaClicked: string): string => {
  const url = new URL(env.GATSBY_FREE_CONSULTATION_CALENDLY_URL);
  url.searchParams.set("utm_source", "website");
  url.searchParams.set("utm_content", ctaClicked);
  return url.toString();
};
